import { useQuery } from "@tanstack/react-query";

interface PresetConfig {
  format: string;
  width: number | null;
  fps: number | null;
  crf: number | null;
  encoder_preset: string | null;
  two_pass_palette: boolean;
}

export interface PresetsInfo {
  presets: Record<string, PresetConfig>;
  max_input_seconds: number;
  max_input_mb: number;
}

async function fetchPresetsInfo(): Promise<PresetsInfo> {
  const res = await fetch("/api/v1/presets");
  if (!res.ok) throw new Error(`presets fetch failed: ${res.status}`);
  return res.json();
}

export function usePresetsInfo() {
  // This rarely changes (only on app restart with a new env value),
  // so cache it generously.
  return useQuery<PresetsInfo>({
    queryKey: ["presets-info"],
    queryFn: fetchPresetsInfo,
    staleTime: 60 * 60 * 1000, // 1h
  });
}
